/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Percentage difference always uses the absolute value of the gap between the two numbers, so the result is zero or positive — it never reports direction. If you need to know which value is larger and by how much in relative terms, use percentage change instead, which keeps a sign.`)
};

const es_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La diferencia porcentual siempre usa el valor absoluto de la diferencia entre los dos números, así que el resultado es cero o positivo — nunca indica dirección. Si necesitas saber qué valor es mayor y en cuánto en términos relativos, usa en su lugar el cambio porcentual, que conserva el signo.`)
};

const de_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der prozentuale Unterschied verwendet immer den absoluten Betrag der Differenz zwischen den beiden Zahlen, das Ergebnis ist also null oder positiv — eine Richtung wird nie angegeben. Wenn du wissen musst, welcher Wert größer ist und um wie viel relativ gesehen, nutze stattdessen die prozentuale Veränderung, die ein Vorzeichen beibehält.`)
};

const nl_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Percentageverschil gebruikt altijd de absolute waarde van het verschil tussen de twee getallen, dus het resultaat is nul of positief — het geeft nooit een richting aan. Als je wilt weten welke waarde groter is en met hoeveel in relatieve termen, gebruik dan percentageverandering, die wel een teken behoudt.`)
};

const fr_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La différence en pourcentage utilise toujours la valeur absolue de l’écart entre les deux nombres, donc le résultat est nul ou positif — elle n’indique jamais de direction. Si vous devez savoir quelle valeur est la plus grande et de combien en termes relatifs, utilisez plutôt la variation en pourcentage, qui conserve un signe.`)
};

const it_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La differenza percentuale usa sempre il valore assoluto del divario tra i due numeri, quindi il risultato è zero o positivo — non indica mai una direzione. Se ti serve sapere quale valore è maggiore e di quanto in termini relativi, usa invece la variazione percentuale, che mantiene un segno.`)
};

const pt_br2_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A diferença percentual sempre usa o valor absoluto da diferença entre os dois números, então o resultado é zero ou positivo — ela nunca indica direção. Se você precisa saber qual valor é maior e por quanto em termos relativos, use a variação percentual, que mantém um sinal.`)
};

const pt_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A diferença percentual usa sempre o valor absoluto da diferença entre os dois números, por isso o resultado é zero ou positivo — nunca indica direção. Se precisar de saber qual valor é maior e em que medida relativa, use antes a variação percentual, que mantém um sinal.`)
};

const ja_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。パーセントの差は常に2つの数値の差の絶対値を使うため、結果はゼロまたは正の値になり、方向は示されません。どちらの値が大きいか、相対的にどれだけ大きいかを知りたい場合は、符号を保持するパーセント変化を使いましょう。`)
};

const zh_pct_difference_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可以。百分比差异始终使用两个数之差的绝对值，因此结果为零或正数——它从不表示方向。如果你需要知道哪个数值更大、相对大多少，请改用保留符号的百分比变化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq3_a", locale)
	if (locale === "en") return en_pct_difference_faq3_a(inputs)
	if (locale === "es") return es_pct_difference_faq3_a(inputs)
	if (locale === "de") return de_pct_difference_faq3_a(inputs)
	if (locale === "nl") return nl_pct_difference_faq3_a(inputs)
	if (locale === "fr") return fr_pct_difference_faq3_a(inputs)
	if (locale === "it") return it_pct_difference_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq3_a(inputs)
	if (locale === "pt") return pt_pct_difference_faq3_a(inputs)
	if (locale === "ja") return ja_pct_difference_faq3_a(inputs)
	return zh_pct_difference_faq3_a(inputs)
};